// Assignment endpoints
export const ASSIGN_POINT = "/company/assign/emissionPoint";
